import {iFrameConnection} from "./services/IFrameConnection";
import {IFrameMessages} from "../blink-sdk/messaging/IFrameMessages";
import {authService, userService} from "../client/connection/Services";
import {iFrameState} from "./services/IFrameState";
import {iFrameMerchantService} from "./services/IframeMerchantService";
import {BUILD_TIMESTAMP, BUILD_VERSION, IFRAME_APP_TYPE, PANEL_TYPE} from "../blink-sdk/Constants";
import {PaywallApp} from "./paywall/PaywallApp";
import {WidgetApp} from "./widget/WidgetApp";
import {iFrameAnalyticsService} from "./services/IFrameAnalyticsService";
import {EventSender} from "../blink-sdk/utils/AnalyticsClient";
import {iFrameAuthService} from "./services/IFrameAuthService";
import {iFrameMetadataModule} from "./services/IFrameMetadataModule";
import {AuthHelper} from "./AuthHelper";


export function initIFrameApp() {
    iFrameConnection.addListenerOnce(IFrameMessages.GET_IFRAME_INIT_DATA, ({publicData, iframeParams, merchantId, merchantToken, iframeAppType, oneCountUserId}) => {
        authService.setPublicData(publicData);
        iFrameState.init(iframeParams);
        iFrameMerchantService.init(merchantId);
        iFrameAuthService.init(merchantToken);
        iFrameAnalyticsService.init(iframeAppType === IFRAME_APP_TYPE.widget
            ? EventSender.wallet
            : EventSender.paywall);
        iFrameMetadataModule.init();

        const executeInit = async () => {
            const iframeAppClass = iframeAppType === IFRAME_APP_TYPE.paywall ? PaywallApp : WidgetApp;
            window.iframeAppType = iframeAppType;
            if (authService.isAuthenticated()) {
                userService.ensureUserDataRequested(() => iframeAppClass.init());
            } else {
                if (oneCountUserId != null) {
                    try {
                        await authService.loginAtEndpoint("/external_providers/login_with_one_count_user/", {
                            oneCountUserId,
                        });
                    } finally {
                        iframeAppClass.init();
                    }
                } else {
                    iframeAppClass.init();
                }
            }
        };
        const canExecuteInit = () => iFrameState.panelType !== PANEL_TYPE.payment || iFrameState.paymentDetails;

        if (!canExecuteInit()) {
            const listener = iFrameState.addUpdateListener(() => {
                if (canExecuteInit()) {
                    listener.remove();
                    executeInit();
                }
            })
        } else {
            executeInit();
        }
    });
    iFrameConnection.sendToSDK(IFrameMessages.GET_IFRAME_INIT_DATA, {
        version: {
            build: BUILD_VERSION,
            time: new Date(BUILD_TIMESTAMP),
        },
    });
}
